module.exports = __webpack_public_path__ + "static/media/license_a2.94b2351b.png";